export enum Role {
  NONE = 'none',
  SUPER_ADMIN = 'super_admin',
  ADMIN = 'admin',
  OPERATIONS = 'operations',
  AUDIT = 'audit',
  MARKETING = 'marketing',
  ACCOUNTING = 'accounting',
}

export type Permission =
  | '*'
  | 'transactions.all'
  | 'accounts.view' | 'accounts.viewInfo' | 'accounts.viewKyc' | 'accounts.manage'
  | 'accounts.edit'
  | 'admin.view' 
  | 'admin.manage' 
  | 'cashInOut.viewCashIn' | 'cashInOut.viewCashOut' | 'cashInOut.all'
  | 'cashInOut.edit' | 'cashInOut.refresh'
  | 'reports.all'
  | 'reports.edit' 
  | 'megapay.skusBillers.buyLoad.view'
  | 'megapay.skusBillers.cashIn.view'
  | 'megapay.skusBillers.payBills.view'
  | 'megapay.skusBillers.stores.view'
  | 'megapay.skusBillers.buyLoad.edit'
  | 'megapay.skusBillers.cashIn.edit'
  | 'megapay.skusBillers.payBills.edit'
  | 'megapay.skusBillers.stores.edit'
  | 'megapay.skusBillers.redeem.view'
  | 'megapay.pushNotification.all'
  | 'megapay.announcement.all'
  | 'megapay.adsDashboard.all'
  | 'megapay.profanityFilter.view'
  | 'megapay.disableLogs.view'
  | 'megapay.rdPdRt.view'
  | 'megapay.referrals.all'
  | 'megapay.skusBillers.disbursementInstitutions.view'
  | 'megapay.skusBillers.disbursementInstitutions.edit';

interface RoleAccess {
  granted: Permission[];
  denied?: string[]; // module-prefix denials
}

export const ROLE_PERMISSIONS: Readonly<Record<Role, RoleAccess>> = Object.freeze({
    [Role.NONE]:        { granted: [] },
    [Role.SUPER_ADMIN]: { granted: ['*'] },
    [Role.ADMIN]:       { granted: ['*'] },
    [Role.OPERATIONS]:  { granted: ['*'], denied: ['reports'] },
    [Role.AUDIT]: {
        granted: [
        'transactions.all',
        'accounts.view', 'accounts.viewInfo', 'accounts.viewKyc',
        'cashInOut.viewCashIn', 'cashInOut.viewCashOut',
        'reports.all',
        ],
    },
    [Role.MARKETING]: {
        granted: [
        'accounts.view', 'accounts.viewInfo', 'accounts.viewKyc',
        'megapay.skusBillers.buyLoad.view', 'megapay.skusBillers.cashIn.view',
        'megapay.skusBillers.payBills.view', 'megapay.skusBillers.stores.view',
        'megapay.skusBillers.disbursementInstitutions.view',
        'megapay.pushNotification.all', 'megapay.announcement.all',
        'megapay.adsDashboard.all', 'megapay.rdPdRt.view', 'megapay.referrals.all',
        ],
    },
    [Role.ACCOUNTING]: {
        granted: [
        'transactions.all',
        'accounts.view', 'accounts.viewInfo', 'accounts.viewKyc',
        'accounts.edit',
        'cashInOut.all',
        'cashInOut.edit', 
        'reports.all',
        'reports.edit', 
    ],
    },
});
